import { PERSONA_IMPORT_PENDING_TTL } from 'Utils/Constants';
import { getLocalStorageValue, setLocalStorageValue } from 'Utils/UtilityFunctions';

const PENDING_IMPORT_KEY = 'pendingPersonaImport';

export type PendingPersonaImport = {
  importId: number
  startedAt: number
};

export const setPendingPersonaImport = (importId: number) => {
  setLocalStorageValue(
    PENDING_IMPORT_KEY,
    JSON.stringify({ importId, startedAt: Date.now() }),
  );
};

export const clearPendingPersonaImport = () => {
  localStorage.removeItem(PENDING_IMPORT_KEY);
};

export const getPendingPersonaImport = (): PendingPersonaImport | null => {
  const raw = getLocalStorageValue(PENDING_IMPORT_KEY);
  if (!raw) return null;
  try {
    const pending = JSON.parse(raw) as PendingPersonaImport;
    const stale = !pending?.importId || !pending?.startedAt
      || Date.now() - pending.startedAt > PERSONA_IMPORT_PENDING_TTL;
    if (stale) {
      clearPendingPersonaImport();
      return null;
    }
    return pending;
  } catch (err) {
    console.log(err);
    clearPendingPersonaImport();
    return null;
  }
};
